<template>
  <div class="product-pool-carousel">
    <ProductCarousel
      :number-of-items="newConfigData.numberOfItems"
      :use-wish-list="newConfigData.useWishList"
      :products="newConfigData.recommendationConfig?.products || []"
      :link-name="newConfigData.linkName"
      :link-url="newConfigData.linkUrl"
      :disable-slideshow="newConfigData.disableSlideshow"
      :image-width="getImageWidth"
      :productids="newConfigData.productIds || []"
      :product-description-alignment="newConfigData.productDescriptionAlignment"
      :picture-skeleton="newConfigData.pictureSkeleton"
      :show-corner-badge="newConfigData.showCornerBadge"
      :show-review-condensed="newConfigData.showReviewCondensed"
      :color-swatch-enhancement="newConfigData.colorSwatchEnhancement"
      :analytics="newConfigData.analytics"
      :simplified-thumbnail="newConfigData.simplifiedThumbnail"
      :is-simplification-on="newConfigData.isSimplificationOn"
      :simplification-with-v1="newConfigData.simplificationWithV1"
      :open-in-new-tab="newConfigData.openInNewTab"
      :simplification-non-bold-percentage-exp="newConfigData.simplificationNonBoldPercentageExp"
      :simplification-remove-sale-exp="newConfigData.simplificationRemoveSaleExp"
      @viewAllEvent="viewAllClicked"
      @onRightChevronClick="rightChevronClicked"
      @onLeftChevronClick="leftChevronClicked"
      @dataLoadStatusEvent="(e) => emits('dataLoadStatusEvent', e)"
    >
      <template
        v-if="newConfigData.title"
        #title
      >
        <component :is="newConfigData.customHeaderType || 'h3'">
          {{ newConfigData.title }}
        </component>
      </template>
    </ProductCarousel>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { ProductCarousel } from '@common-vue/product-carousel';
import { getProductThumbnailSize } from '../../utils/utils';
import {
  fireProductPoolAllClicked,
  fireProductPoolChevronClicked,
} from '../../analytics/analyticsEvent';

const props = defineProps({
  configData: {
    type: Object,
    default: () => ({}),
  },
});

const emits = defineEmits(['dataLoadStatusEvent']);

const newConfigData = computed(() => ({
  ...props.configData,
  useWishList: true,
  disableSlideshow: true,
  pictureSkeleton: true,
  showCornerBadge: true,
}));
const getImageWidth = computed(() => getProductThumbnailSize(props.configData?.numberOfItems));

const viewAllClicked = () => fireProductPoolAllClicked(props.configData?.linkName);
const rightChevronClicked = () => fireProductPoolChevronClicked('right');
const leftChevronClicked = () => fireProductPoolChevronClicked('left');
</script>
